import { makeStyles, createStyles, Button, Theme, IconButton } from '@material-ui/core';
import React, { useContext, useMemo, useState, useEffect, FC } from 'react';
import json_pointer from 'json-pointer';

import { AppearableDefinition } from '../services/layout';

import { FormContext, useVisibility, registry, FormControlProps, useDataValue, useDataFieldValidity } from '..';
import { Edit } from '@material-ui/icons';

var useStyles = makeStyles(function (theme: Theme) {
  return createStyles({
    root: {
      display: 'flex',
      // flexDirection: 'column',
      flex: 1,
    },
    appearButton: {
      marginTop: '-1px',
      alignSelf: 'flex-end',
      // marginTop: theme.spacing(-6),
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.divider,
    },
  });
});

export const Appearable: FC<FormControlProps<AppearableDefinition>> = function (props) {
  const form = useContext(FormContext).form;
  const definition = useMemo(function () {
    return json_pointer.get(form.definition, props.path);
  }, [props.path, form.id]);
  const [ isVisible, setIsVisible ] = useState(false);
  const value = useDataValue(definition.child.dataPath);
  const classes = useStyles(props);

  const error = useDataFieldValidity(definition.child.dataPath);

  useEffect(() => {
    if (error && !isVisible) {
      setIsVisible(true);
    }
  }, [error]);

  const dom = useMemo(() => {
    const Component = registry.getComponent(definition.child.type);
  
    if (!Component) {
      throw new Error('No such control ' + definition.child.type + ' exists');
    }

    if (isVisible || value) {
      return (
        <div className = { classes.root }>
          <Component
            path = { props.path.concat('/child') }
            definition = { definition.child }>
          </Component>
        </div>
      )
    } else {
      return (
        <div className = { classes.root }>
          <IconButton
            onClick = { () => setIsVisible(true) }>
            <Edit></Edit>
          </IconButton>
        </div>
      );
    }
  }, [value, isVisible]);

  return dom;
};

registry.registerComponent('Appearable', Appearable);
